import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  hexagon: {
    justifyContent: 'center',
    alignItems: 'center',
  },

  hexagonInner: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },

  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    fontSize: 18,
    color: '#535353',
    fontFamily: 'Montserrat',
    fontWeight: '700',
    textAlign: 'center',
  },

  subTitle: {
    fontSize: 16,
    color: '#535353',
    fontFamily: 'Montserrat',
    fontWeight: '400',
    textAlign: 'center',
  },

  separator: {
    backgroundColor: '#535353',
    height: 1,
    marginVertical: 10,
    alignSelf: 'center',
  },

  secondTitle: {
    fontSize: 18,
    color: '#535353',
    fontFamily: 'Montserrat',
    fontWeight: '700',
    textAlign: 'center',
  },
});
